import axios from "axios";
import { COOKIE_PREFIX, STORAGE_KEYS } from "../constants";
import { StorageService } from "./StorageService";

const getCsrfTokenFromCookie = () => {
    const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${COOKIE_PREFIX}csrftoken=`));
    return cookieValue ? cookieValue.split("=")[1] : null;
};

const apiClient = axios.create({
    // baseURL: "http://localhost:8000/api",
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,  // Django에서 세션 쿠키를 받을 수 있도록 설정
    headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
    const csrfToken = getCsrfTokenFromCookie();
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken; // CSRF 토큰을 HTTP 헤더에 추가
    }

    const token = StorageService.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

export { apiClient };